import React from 'react';
import { Box } from '@mui/material';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import Hero from './Hero';
import Mentorship from './Mentorship';
import CTA from './CTA';
import Spotlight from './Spotlight';

function Community() {
    return (
        <Box>
            <Header />
            <Hero />
            <Mentorship />
            <CTA />
            <Spotlight />
            <Footer />
        </Box>
    );
}

export default Community;
